module.exports = __webpack_public_path__ + "static/media/hm.c1cfef6b.svg";